import { MainAppService } from "src/modules/app-template/services/main-app.service";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class WfPortalInterface {

    constructor(private app: MainAppService, private familyName: string) {
    }

    translate(text: string, params: OrdinaryObject): string {
        return this.app.t("wfs.families." + this.familyName + ".messages." + text, params, text); 
    }
}
